import "./App.css";
import { useState, useEffect } from "react";
import Home from "./containers/Home";
import Login from "./containers/Login";
import Register from "./containers/Register";
import { Routes, Route } from "react-router-dom";
import Nav from "./components/Nav";
import {
  AlertContext,
  PropertyContext,
  UserContext,
} from "./context/MainContext";
import ResidentialAdd from "./containers/ResidentialAdd";
import PropertyView from "./containers/PropertyView";
import Profile from "./containers/Profile";
import { currentUser } from "./actions/userCurrent";
import { initializeKeepAlive } from "./services/initializeKeepAlive";
// import About from './containers/About';
import Keys from "./containers/Keys";
import Alert from "./components/Alert";
import MyProperties from "./components/MyProperties";
import User from "./containers/User";
import UserProperties from "./containers/UserProperties";
import All from "./containers/All";
import Admin from "./containers/Admin";
import HorizontalAdd from "./components/HorizontalAdd";
import Store from "./containers/Store";
import ProtectedRoute from "./containers/ProtectedRoute";
import AuthRoute from "./containers/AuthRoute";
import Sold from "./containers/Sold";
import Professionals from "./containers/Professionals";
import Search from "./containers/Search";
import Leased from "./containers/Leased";
import AdDash from "./containers/AdDash";
import AdStore from "./containers/AdStore";
import Pending from "./containers/Pending";
import OffMarket from "./containers/OffMarket";
import Withdrawn from "./containers/Withdrawn";
import Expired from "./containers/Expired";
import { SHOW_ADS } from "./constants/FeatureFlags";
function App() {
  const [propertyClicked, setPropertyClicked] = useState(null);
  const [user, setUser] = useState(null);
  const [alert, setAlert] = useState(null);
  const [universalAd, setUniversalAd] = useState(false);
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    currentUser({ setUser }).finally(() => setAuthChecked(true));
  }, [setUser]);

  // Clear cookies if auth state is lost on hard refresh
  useEffect(() => {
    if (authChecked && !user) {
      // Clear any lingering session data
      document.cookie.split(";").forEach((c) => {
        document.cookie = c
          .replace(/^ +/, "")
          .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
      });
    }
  }, [authChecked, user]);

  // Initialize keep-alive pings for Render API
  useEffect(() => {
    const cleanup = initializeKeepAlive();
    return cleanup;
  }, []);
  return (
    <div className="flex flex-col relative items-center justify-center">
      {SHOW_ADS && universalAd && (
        <div className="fixed bottom-0 z-50 border-2">
          <HorizontalAdd setUniversalAd={setUniversalAd} />
        </div>
      )}
      <AlertContext.Provider value={{ alert, setAlert }}>
        <UserContext.Provider value={{ user, setUser }}>
          <header className="max-w-[2200px] tablet:px-16 homebreak:px-32 w-full">
            <Nav />
            <div className="w-full flex justify-center relative top-8">
              <Alert />
            </div>
          </header>

          <main className="max-w-[2200px] tablet:px-16 homebreak:px-32 w-full">
            <PropertyContext.Provider
              value={{ propertyClicked, setPropertyClicked }}
            >
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/active" element={<All />} />
                {/* <Route path="/about" element={<About/>}/> */}
                <Route path="/keys" element={<Keys />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route
                  path="/residentialAdd"
                  element={
                    <AuthRoute>
                      <ResidentialAdd />
                    </AuthRoute>
                  }
                />
                <Route
                  path="/myproperties"
                  element={
                    <AuthRoute>
                      <MyProperties />
                    </AuthRoute>
                  }
                />
                <Route path="/property/:id" element={<PropertyView />} />
                <Route
                  path="/profile"
                  element={
                    <AuthRoute>
                      <Profile />
                    </AuthRoute>
                  }
                />
                <Route path="/user/:id" element={<User />} />
                <Route path="/user/:id/active" element={<UserProperties />} />
                <Route path="/adminpanell" element={<ProtectedRoute />} />
                <Route
                  path="/store"
                  element={
                    <AuthRoute>
                      <Store />
                    </AuthRoute>
                  }
                />
                <Route path="/sold" element={<Sold />} />
                <Route path="/leased" element={<Leased />} />
                <Route path="/pending" element={<Pending />} />
                <Route path="/offmarket" element={<OffMarket />} />
                <Route path="/withdrawn" element={<Withdrawn />} />
                <Route path="/expired" element={<Expired />} />
                <Route path="/professionals" element={<Professionals />} />
                <Route path="/search/:id" element={<Search />} />
                <Route
                  path="/addash"
                  element={
                    <AuthRoute>
                      <AdDash />
                    </AuthRoute>
                  }
                />
                <Route
                  path="/adstore"
                  element={
                    <AuthRoute>
                      <AdStore />
                    </AuthRoute>
                  }
                />
              </Routes>
            </PropertyContext.Provider>
          </main>

          <footer className="max-w-[2200px] tablet:px-16 homebreak:px-32 w-full"></footer>
        </UserContext.Provider>
      </AlertContext.Provider>
    </div>
  );
}

export default App;
